// Grade display label. Legacy citrus grades are short codes ('1', '2', 'P')
// that read as "Class 1" / "Class P" on labels, notes and reports. Registry
// grades (commodity_grades, mig 832) like 'Class 1' or 'Juice' are already
// self-describing — prefixing them again would print "Class Class 1" on
// customer-facing documents.
export function formatGradeLabel(grade: string): string {
  return grade.length <= 2 ? `Class ${grade}` : grade
}
